import { TableRow } from "@carbon6/c6-frontend-design";
import type { TrainingShareLinkTargetKind, TrainingShareLinkView } from "@/api/trainingShareLinks";
import { parseCheckpointTag, type CheckpointTag } from "@/modules/training/public";
import { parseUtcMs } from "@/utils/datetime";
import {
  checkpointDisplayLabel,
  checkpointSizeLabel,
} from "../sessionDetail/trainingSessionDetailFormat";

const TARGET_KIND_LABEL: Record<TrainingShareLinkTargetKind, string> = {
  policy: "Policy",
  checkpoint: "Checkpoint",
  raw_checkpoint: "Raw Checkpoint",
};

// 공유 링크 한 행. 가능한 동작(canReissue/canRevoke)은 서버가 보는 사람 기준으로 계산한 값을 그대로
// 쓴다. 발행자 이름을 비교해 "내 링크인지" 추측하면 이름이 같은 다른 사람에서 틀린다.
export class ShareLinkTableRow extends TableRow {
  readonly uuid: string;
  readonly kindLabel: string;
  // 대상의 첫 줄. Policy 면 이름, 체크포인트면 태그 라벨이다.
  readonly targetLabel: string;
  readonly filename: string;
  readonly sessionId: string;
  // 발급 시점 세션 이름. 모르면 null 이고, 링크는 세션 id 앞부분으로 표시한다.
  readonly sessionName: string | null;
  // 세션 창이 체크포인트 탭에서 가리킬 행. 태그를 모르면 null 이고, 탭만 연다.
  readonly checkpointTag: CheckpointTag | null;
  readonly sizeLabel: string;
  readonly issuerName: string;
  readonly createdAtMs: number | null;
  readonly expiresAtMs: number | null;
  readonly accessCount: number;
  readonly lastAccessedAtMs: number | null;
  readonly canReissue: boolean;
  readonly canRevoke: boolean;

  constructor(link: TrainingShareLinkView) {
    super(null);
    this.uuid = link.uuid;
    this.kindLabel = TARGET_KIND_LABEL[link.target_kind];
    this.targetLabel = link.policy_name ?? checkpointDisplayLabel(link.checkpoint_tag);
    this.filename = link.filename;
    this.sessionId = link.training_session_id;
    this.sessionName = link.session_display_name;
    this.checkpointTag = parseCheckpointTag(link.checkpoint_tag);
    this.sizeLabel = checkpointSizeLabel(link.size_bytes);
    this.issuerName = link.issued_by.display_name;
    this.createdAtMs = parseUtcMs(link.created_at);
    this.expiresAtMs = parseUtcMs(link.expires_at);
    this.accessCount = link.access_count;
    this.lastAccessedAtMs = parseUtcMs(link.last_accessed_at);
    this.canReissue = link.can_reissue;
    this.canRevoke = link.can_revoke;
  }

  // 만료 판정은 보는 시각 기준이다. 목록을 받은 뒤 시간이 지나도 칩이 바뀌도록 호출부가 now 를 준다.
  isExpired(nowMs: number): boolean {
    return this.expiresAtMs !== null && this.expiresAtMs <= nowMs;
  }

  getRowId(): string {
    return this.uuid;
  }

  canShow(): boolean {
    return true;
  }

  canSelect(): boolean {
    return false;
  }
}
